<template>
	<div class="popup_inner review-popup" :class="{'ajax_processed': isLoading}">
		<div class="popup_head">Поделитесь мнением</div>
		<div class="popup_cont popup_cont--info">
			<div class="rate-block">
				<fieldset class="rate">
					<input v-model="formData.score" type="radio" id="rating10" value="5">
					<label for="rating10" title="5"></label>
					<input v-model="formData.score" type="radio" id="rating9" value="4.5">
					<label for="rating9" title="4.5" class="half"></label>
					<input v-model="formData.score" type="radio" id="rating8" value="4">
					<label for="rating8" title="4"></label>
					<input v-model="formData.score" type="radio" id="rating7" value="3.5">
					<label for="rating7" title="3.5" class="half"></label>
					<input v-model="formData.score" type="radio" id="rating6" value="3">
					<label for="rating6" title="3"></label>
					<input v-model="formData.score" type="radio" id="rating5" value="2.5">
					<label for="rating5" title="2.5" class="half"></label>
					<input v-model="formData.score" type="radio" id="rating4" value="2">
					<label for="rating4" title="2"></label>
					<input v-model="formData.score" type="radio" id="rating3" value="1.5">
					<label for="rating3" title="1.5" class="half"></label>
					<input v-model="formData.score" type="radio" id="rating2" value="1">
					<label for="rating2" title="1"></label>
					<input v-model="formData.score" type="radio" id="rating1" value="0.5">
					<label for="rating1" title="0.5" class="half"></label>
					<input v-model="formData.score" type="radio" id="rating0" value="0">
					<label for="rating0" title="0"></label>
				</fieldset>
				<div class="rate-block__actions">
					<button class="btn" @click="onSubmit('score')">Отправить только оценку</button>
				</div>

			</div>
			<div class="form_row form_row--179 required" :class="{error: v$.formData.name.$errors.length}">
				<label>Имя<span class="req">*</span></label>
				<input v-model="formData.name" type="text" required="required" value="">
			</div>
			<div class="form_row form_row--180  required" :class="{error: v$.formData.email.$errors.length}">
				<label>E-mail<span class="req">*</span></label>
				<input v-model="formData.email" type="email" required="required" value=""></div>
			<div class="form_row form_row--181  required" :class="{error: v$.formData.text.$errors.length}">
				<label>Текст отзыва<span class="req">*</span></label>
				<textarea v-model="formData.text" required="required"></textarea></div>
      <div class="consent-accepted" v-if="confirmConsent">Согласие на обработку персональных данных принято</div>
		</div>
		<div class="popup_bottom_bl">
			<div v-if="!confirmConsent" class="confirm-consent confirm-consent--review">
				<div class="confirm-consent__text">
					<slot></slot>
					Подтвердите <a href="/upload/Согласие.pdf" target="_blank">согласие</a> на обработку <br> Ваших персональных данных
				</div>
				<div class="confirm-consent__btn">
					<button class="btn btn_red" type="button" @click="confirmConsent = true">Подтвердить</button>
				</div>
			</div>
			<div v-else class="consent-block consent-block--review">
				<div class="consent-final__text">
					Нажимая кнопку, Вы подтверждаете, что ознакомились с <a href="/upload/Политикa-конфиденциальности.pdf" target="_blank">Политикой конфиденциальности</a>
				</div>
				<div class="consent-final__btn">
					<button class="btn btn_red" @click="onSubmit('review')">Отправить отзыв и оценку</button>
				</div>
 			</div>
		</div>
</div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import { mapActions, mapGetters } from "vuex";
import { isRecaptchaError } from '../../utils/errors.js';

export default {
	name: 'AddReviewForm',
	setup: () => ({ v$: useVuelidate(), isRecaptchaError }),
	data() {
		return {
			formData: {
				name: '',
				email: '',
				score: 0,
				text: '',
			},
            isLoading: false,
			confirmConsent: false,
		}
	},
	validations () {
		return {
			formData: {
				name: { required },
				email: { required, email },
				text: { required },
			}
		}
	},
	computed: {
		...mapGetters({
			getYandexSiteKey: 'getYandexSiteKey',
			getReviewProductId: 'getReviewProductId',
			getReviewPreselectedScore: 'getReviewPreselectedScore',
		})
	},
	watch: {
		'getReviewPreselectedScore'() {
			this.formData.score = this.getReviewPreselectedScore;
		}
	},
	methods : {
		async onSubmit(type) {
			if (type !== 'score') {
				const isValid = await this.v$.formData.$validate();
				if (!isValid) return
			}
            this.isLoading = true;
            this.executeYandexCaptcha(() => this.sendReview(type));
		},
        async sendReview(type) {
            let data = {};
            if (type === 'score') {
                data = {
                    productId: this.getReviewProductId,
                    score: this.formData.score,
                };
            } else {
                data = this.formData;
                data.productId = this.getReviewProductId;
            }
            const token = window.smartCaptcha && window.smartCaptcha.getResponse() || '';
            const response = await this.requestAddReview({data, yandexCaptchaToken: token});
            if (type === 'score') {
                if (response.data) {
                    this.resetForm();
                    this.v$.formData.$reset();
                    window.openCompactModal('add-score-success');
                }
            } else {
                if (response.data) {
                    this.resetForm();
                    this.v$.formData.$reset();
                    window.openCompactModal('add-review-success');
                }
            }
            this.isLoading = false;
        },
		resetForm() {
			this.formData.name = '';
			this.formData.email = '';
			this.formData.text = '';
			this.formData.score = 0;
		},
		...mapActions({
			requestAddReview: 'requestAddReview',
            executeYandexCaptcha: 'executeYandexCaptcha',
		}),
	},
}
</script>
